import { HTTP } from "../../../http-common";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "../../../models/httpError";
import { Sip } from "../../../models/Sip";
import { SipRow } from "../../../models/SipRow";

const state = {
  sip: new Sip(),
  message: new httpError()
};

//getters

const getters = {
  getField
};

//Mutations
const mutations = {
  addRow(state) {
    var length = state.sip.sipRows[0]
      ? state.sip.sipRows[0].contractLength
      : 24;
    state.sip.sipRows.push(new SipRow({ contractLength: length }));
  },
  clearRows(state) {
    state.sip = new Sip();
    state.sip.sipRows = [];
    state.sip.sipRows.length = 0;
    state.sip.sipRows.push(new SipRow());
    state.message = new httpError();
  },
  removeSip(state, rows) {
    if (state.sip.sipRows.length > 0) {
      for (var index = state.sip.sipRows.length; index--; ) {
        if (
          rows.includes(x => x.extension == state.sip.sipRows[index].extension)
        ) {
          state.sip.sipRows.splice(index, 1);
        }
      }
    }
  },
  setProgress(state, message) {
    state.message = message;
  },
  setRows(state, sips) {
    state.sip.sipRows.length = 0;
    state.sip.sipRows = sips;
  },
  setSip(state, sip) {
    state.sip = sip;
  },
  deleteRow(state) {
    state.sip.sipRows.pop();
  },
  removeHardware(state) {
    state.sip.hardware = "none";
  },
  changeQuantity(state, quantity) {
    state.sip.sipRows[0].quantity = quantity;
  },
  removeSipRow(state, index) {
    state.sip.sipRows.splice(index, 1);
  },
  updateField
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit("clearRows");
  },
  removeHardware({ commit }) {
    commit("removeHardware");
  },
  populateSips({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      dispatch("setMessage", new httpError());
      var response = HTTP.get(
        "order/GetSipOnOrder/" + rootState.orders.rows[0].orderID
      );
      response
        .then(function(data) {
          if (data.status === 200) {
            commit("setSip", data.data);
            dispatch(
              "setMessage",
              new httpError({ message: "Retrieved OK", httpStatus: 200 })
            );
          }
          if (data.status === 204) {
            commit(
              "setSip",
              new Sip({
                connectionType: "extension",
                orderID: rootState.orders.rows[0].orderID,
                sipRows: [new SipRow({ extension: 500, contractLength: 24 })]
              })
            );
          }
          resolve(data.data);
        })
        .catch(function(err) {
          dispatch(
            "setMessage",
            new httpError({ message: "Error" + err.message, httpStatus: 500 })
          );

          reject(err);
        });
    });
  },
  updateRows({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        "order/UpdateSipOnOrder/" + rootState.orders.rows[0].orderID,
        state.sip
      );
      response
        .then(data => {
          if (data.status == 200) {
            commit("setSip", data.data);
            dispatch(
              "setMessage",
              new httpError({ message: "Saved OK", httpStatus: 200 })
            );
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({ message: err.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  removeRows({ state, commit, dispatch }, newVal) {
    return new Promise(resolve => {
      var oldVal = 0 || state.sip.sipRows.length;
      var rows = [];
      for (var i = oldVal; i > newVal; i--) {
        if (state.sip.sipRows[i - 1].id > 0)
          rows.push(state.sip.sipRows[i - 1]);
        commit("deleteRow");
      }
      dispatch("persistRows", rows).then(data => {
        resolve(data);
      });
    });
  },
  removeSipFromOrder({ state, dispatch }, sipID) {
    return new Promise((resolve, reject) => {
      if (sipID && sipID > 0) {
        HTTP.post(`Order/DeleteSipsFromOrder/${state.sip.orderID}`, sipID)
          .then(data => {
            resolve(data);
          })
          .catch(err => {
            dispatch(
              "setMessage",
              new httpError({
                message: err.message,
                httpStatus: 500
              })
            );
            reject(err);
          });
      }
    });
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
